export default __webpack_public_path__ + "static/media/300_ml_e.a8bba74a.svg";